import "./hoverCard.css"
import HoverCard from "./HoverCard"
import HoverCardContent from "./HoverCardContent"
import HoverCardTrigger from "./HoverCardTrigger"

export type { HoverCardProps } from "./HoverCard"
export type { HoverCardContentProps } from "./HoverCardContent"
export type { HoverCardTriggerProps } from "./HoverCardTrigger"
export default Object.assign(HoverCard, {
  Content: HoverCardContent,
  Trigger: HoverCardTrigger,
})
